<template>
    <v-sheet>
        <v-row>
            <v-col>
                <h4 class="text-h4">Sales By Item Analysis Report<span class="grey--text" v-if="form.from && form.to"> - {{ form.from }} to {{ form.to }}</span></h4>
                <p class="text-subtitle-1">Sales By Item Analysis Report</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn-toggle v-model="period">
                    <v-btn @click="periodToday">Today</v-btn>
                    <v-btn @click="periodYesterday">Yesterday</v-btn>
                    <v-btn @click="periodCurrentMonth">Current Month</v-btn>
                    <v-btn @click="periodPreviousMonth">Previous Month</v-btn>
                    <v-btn>Custom Period</v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <v-row v-if="period == 4">
            <v-col>
                <v-row class="align-center">
                    <v-col cols="12" md="3">
                        <PDatePicker
                            label="From"
                            outlined
                            hide
                            v-model="form.from"
                            />
                    </v-col>
                    <v-col cols="12" md="3">
                        <PDatePicker
                            label="To"
                            outlined
                            hide
                            v-model="form.to"
                            />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn color="primary" depressed @click="submit" block :loading="loading">
                            <v-icon>mdi-magnify</v-icon>
                            search
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet rounded class="pa-6">
                    <div class="d-flex align-center justify-space-around">
                        <v-icon size="80" color="primary">mdi-handshake</v-icon>
                        <div class="me-4">
                            <div >Total Agreements</div>
                            <div class="text-h3">{{ formatNumber(totalQuantityOrdersByItem) }}</div>
                        </div>
                        <div>
                            <div>Produced</div>
                            <div class="text-h4 success--text">{{ formatNumber(data.period_total_sales.quantity) }}</div>
                            <div class="mt-2">To Be Fulfilled</div>
                            <div class="text-h4 error--text">{{ formatNumber(totalQuantityOrdersByItem - data.period_total_sales.quantity) }}</div>
                        </div>
                    </div>
                </v-sheet>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
                <v-sheet rounded class="pa-6">
                    <div  class="d-flex align-center justify-space-around">
                        <v-icon size="80" color="primary">mdi-truck-fast-outline</v-icon>
                        <div class="me-4">
                            <div >Total Production</div>
                            <div class="text-h3">{{ formatNumber(totalQuantitySalesByItem) }}</div>
                        </div>
                        <div>
                            <div>From Period</div>
                            <div class="text-h4 success--text">{{ formatNumber(data.period_total_sales.quantity) }}</div>
                            <div class="mt-2">From Previous</div>
                            <div class="text-h4 warning--text">{{ formatNumber(totalQuantitySalesByItem - data.period_total_sales.quantity) }}</div>
                        </div>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <h5 class="text-h5">Production Breakdown</h5>
                <v-divider class="mt-4"></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet>
                    <v-simple-table dense v-if="!hasErrors">
                        <thead class="font-weight-bold">
                            <tr>
                                <th></th>
                                <th>Item Code</th>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Average Price</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d, i) in data.sales_by_item" :key="i">
                                <td>
                                    <v-btn icon @click="goToInvoiceBreakdown(d.item_id,d.item_name)">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </td>
                                <td>{{d.item_code}}</td>
                                <td>{{d.item_name}}</td>
                                <td>{{formatNumber(d.quantity)}}</td>
                                <td>{{formatNumber(d.average_price)}}</td>
                                <td>{{formatNumber(d.value)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="font-weight-bold secondary">
                                <td colspan="3">Total</td>
                                <td>{{formatNumber(totalQuantitySalesByItem)}}</td>
                                <td></td>
                                <td>{{formatNumber(totalValueSalesByItem)}}</td>
                            </tr>
                        </tfoot>
                    </v-simple-table>
                    <div v-else class="pa-6 text-center surface">
                        <div class="red--text my-1" v-for="(e, i) in errors" :key="i">{{e}}</div>
                        <v-btn outlined class="mt-6" @click="submit">
                            <v-icon left>mdi-refresh</v-icon>
                            Try Again
                        </v-btn>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <h5 class="text-h5">Sales Agreements Breakdown</h5>
                <v-divider class="mt-4"></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-sheet>
                    <v-simple-table dense>
                        <thead class="font-weight-bold">
                            <tr>
                                <th></th>
                                <th>Item Code</th>
                                <th>Item Name</th>
                                <th>Quantity</th>
                                <th>Average Price</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(d, i) in data.orders_by_item" :key="i" >
                                <td>
                                    <v-btn icon @click="goToAgreementBreakdown(d.item_id,d.item_name)">
                                        <v-icon>mdi-magnify</v-icon>
                                    </v-btn>
                                </td>
                                <td>{{d.item_code}}</td>
                                <td>{{d.item_name}}</td>
                                <td>{{formatNumber(d.quantity)}}</td>
                                <td>{{formatNumber(d.average_price)}}</td>
                                <td>{{formatNumber(d.value)}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="font-weight-bold secondary">
                                <td colspan="3">Total</td>
                                <td>{{formatNumber(getTotal(data.orders_by_item, "quantity"))}}</td>
                                <td></td>
                                <td>{{formatNumber(getTotal(data.orders_by_item, "value"))}}</td>
                            </tr>
                        </tfoot>
                    </v-simple-table>
                </v-sheet>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <h5 class="text-h5">Agreements Date Breakdown</h5>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Year</th>
                            <th>Month</th>
                            <th>Quantity</th>
                            <th>Percentage</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, i) in data.sales_order_period" :key="i">
                            <td>
                                <span v-if="d.year">{{ d.year }}</span>
                                <span v-else>
                                    <v-icon color="warning" left>mdi-alert-circle-outline</v-icon>
                                    <span class="warning--text">Without Agreements</span>
                                </span>
                            </td>
                            <td>
                                <span v-if="d.month_name">{{ d.month_name }}</span>
                                <span v-else>
                                    <v-icon color="warning" left>mdi-alert-circle-outline</v-icon>
                                    <span class="warning--text">Without Agreements</span>
                                </span>
                            </td>
                            <td>{{ formatNumber(d.quantity) }}</td>
                            <td>{{ formatNumber(d.quantity/getTotal(data.sales_order_period, "quantity")*100, 4)}}%</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr class="secondary">
                            <td colspan="2">Total</td>
                            <td class="font-weight-bold">{{ formatNumber(getTotal(data.sales_order_period, "quantity")) }}</td>
                            <td></td>
                        </tr>
                    </tfoot>
                </v-simple-table>
            </v-col>
        </v-row>
        <LoadingDialog message="Please Wait ..." v-model="loading"/>
    </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PDatePicker from './../../components/common/PDatePicker';
import LoadingDialog from './../../components/common/LoadingDialog';
import { getTotal } from './../../utils/accounting';
import { formatNumber } from 'accounting';
import moment from 'moment';

export default {
    name: "SalesByItemReportView",
    components: {
        PDatePicker,
        LoadingDialog
    },
    data() {
        return {
            form: {
                from: "",
                to: ""
            },
            period: 0
        }
    },
    computed: {
        ...mapGetters("sales/report/salesByItemReport", [
            "loading", "data", "from", "to", "errors", "hasErrors"
        ]),
        totalQuantitySalesByItem() {
            if(this.data && Array.isArray(this.data.sales_by_item)) {
                return getTotal(this.data.sales_by_item, "quantity");
            }
            return 0;
        },
        totalValueSalesByItem() {
            if(this.data && Array.isArray(this.data.sales_by_item)) {
                return getTotal(this.data.sales_by_item, "value");
            }
            return 0;
        },
        totalQuantityOrdersByItem() {
            if(this.data && Array.isArray(this.data.sales_by_item)) {
                return getTotal(this.data.orders_by_item, "quantity");
            }
            return 0;
        },
        totalValueOrdersByItem() {
            if(this.data && Array.isArray(this.data.sales_by_item)) {
                return getTotal(this.data.orders_by_item, "value");
            }
            return 0;
        }
    },
    methods: {
        getTotal,
        ...mapActions({
            updateParams: "sales/report/salesByItemReport/updateParams"
        }),
        formatNumber(n) {
            return formatNumber(n, 2);
        },
        submit() {
            this.updateParams(this.form);
        },
        periodToday() {
            this.form = {
                from: moment().format("YYYY-MM-DD"),
                to: moment().format("YYYY-MM-DD"),
            }
            this.submit();
        },
        periodYesterday() {
            this.form = {
                from: moment().subtract(1, "day").format("YYYY-MM-DD"),
                to: moment().subtract(1, "day").format("YYYY-MM-DD"),
            }
            this.submit();
        },
        periodCurrentMonth() {
            this.form = {
                from: moment().startOf("month").format("YYYY-MM-DD"),
                to: moment().endOf("month").format("YYYY-MM-DD"),
            }
            this.submit();
        },
        periodPreviousMonth() {
            this.form = {
                from: moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
                to: moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
            }
            this.submit();
        },
        goToInvoiceBreakdown(item_id, item_name) {
            this.$router.push({name: "InvoiceItemBreakdown", query: {item_id: item_id, item_name: encodeURI(item_name), from: this.form.from, to: this.form.to}})
        },
        goToAgreementBreakdown(item_id, item_name) {
            this.$router.push({name: "AgreementItemBreakdown", query: {item_id: item_id, item_name: encodeURI(item_name), from: this.form.from, to: this.form.to}})
        }
    },
    created() {
        this.form = {from: this.from, to: this.to};
        if(this.data.length == 0){
            this.submit();
        }
    }
}
</script>

<style>

</style>